module.exports = __webpack_public_path__ + "img/htcm_03.05e50655.jpg";